

/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-use-before-define */
/* eslint-disable no-unused-vars */

import React, { useCallback, useEffect, useState } from 'react'
import { APIEndpoint, DFPAPIEndpoint } from '../../../utils/axios';
import { NGODatePicker} from '../../../common';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import pieChartIcon from '../../../assets/icons/pi-chart-sales.svg';
import totalOrders from '../../../assets/icons/total-orders.svg';
import totalSales from '../../../assets/icons/total-sales.svg';
import monitor from '../../../assets/icons/monitor.svg'
import { useTranslation } from 'react-i18next';
import LoadingIn from '../../../assets/loadingIn.gif';
import SalesAccordion from './renderers/salesAccordion';
import { useNavigate } from "react-router-dom";
import Select from 'react-select';
import usePermissions from '../../../utils/userPermissions';
import {customSelSearch} from "../../../utils/configs";


export const DynamicNewPage = (props) => {
  const { ready } = useTranslation();
  const [state, setState] = useState({emptInst:false,showOrders:false,disabled:false,resetDataSource:false,tailNum:[{key: 0, label: "Select Tail Number", value: ''}]});
  const [optionsLocations,setOptionsLocations]=useState([{key: 0, label: 'Select Location', value: ''}]);


  const { hasPermission: editSalesNew } = usePermissions('edit', 'orn:Store:ViewSalesInfo');
  const { hasPermission: viewDetailsSalesNew } = usePermissions('view', 'orn:Store:ViewSalesInfo');
  const { hasPermission: viewSalesNew} = usePermissions('viewDetails', 'orn:Store:ViewSalesInfo');


  const sType = localStorage.getItem('sType');
  const DOMAIN = (sType === 'dfp' ? DFPAPIEndpoint : APIEndpoint);
  useEffect( () => {
    fetchAircrafts();
      }, []);

      useEffect(() => {


        if (
          state.startDate === undefined ||
          state.InstanceState === undefined ||
          state.sectors === undefined ||
          state.emptInst ||
          state.instanceChange ||
          (!state.tailNum.includes(null) && state.tailNum[0].value) ||
          state.startDate ||
          state.InstanceState ||
          state.sectors ||
          state.emptInst === "" ||
          state.instanceChange === "" ||
          state.tailNum === "" ||
          !state.startDate ||
          state.InstanceState === "" ||
          state.sectors === ""
        ) {
          // fetchOperationsPanel();
        }
      }, []);


  const fetchAircrafts = useCallback(
   async () => {
    try {
       const resp = await APIEndpoint.get('airports');
    if (resp.items.length > 0) {
      const options = [{key: 0, label: 'Select Location', value: ''}];
      resp.items.filter( (fieldValue, index) => {
        options.push({key: fieldValue.id, label: fieldValue.locationCode, value: fieldValue.locationCode});
        return fieldValue;
      });
      setOptionsLocations(options)
    } else {
      console.log('Log: Error while fetching warehouses');
    }
    } catch (error) {

    }

  },
    [],
  )


  const onDateChange=(e)=>{
    setState( (_prev) => {
        return { ..._prev,startDate:e.target.value,resetDataSource:!state.resetDataSource}
      });
  }

  const onInstanceChange=(e)=>{
    setState( (_prev) => {
        return { ..._prev,instanceChange:e.target.value,resetDataSource:!state.resetDataSource}
      });
  }



  const onChangeTailNumber=(e)=>{
    setState( (_prev) => {
        return { ..._prev,tailNum:[e],resetDataSource:!state.resetDataSource}
      });
  }


  return (
      <div className="op-aircraft-container flexCol full-flex ag-theme-alpine-dark">
      {
        <>

          <div className="flexRow gap10 width100 justifyContentFlexStart alignItemsCenter">
            <div>
            <input className="edit-input-synced-search" onChange={onInstanceChange} type="search" placeholder="Search Group/Sector, PNR, Order ID" value={state.instanceChange||null}/>
            </div>

            {state && state.tailNum && editSalesNew? (<div className='felxCol' style={{marginBottom:'0.2rem'}}>
            <Select
              options={optionsLocations}
              defaultValue={state.tailNum[0]?.label ? state.tailNum[0]?.label : ''}
              value={optionsLocations?.filter(function (option) {
                return (
                  state.tailNum.length && state.tailNum[0]&&
                  state.tailNum.find((sc) => sc.label === option.label)
                );
              })}
              onChange={onChangeTailNumber}
              styles={customSelSearch}
              isOpenMenu={state.isOpenMenu}
              placeholder="Uplift Location"
              isSearchable={true}
              isClearable={true}
              className="selectMenu-meals"
            />
          </div>):<></>}

            <button className="orderStatus-div">
            <>
                    <NGODatePicker
                      style={{width: '13rem',border:'0.7px solid #fff'}}
                      value={state.startDate?new Date(state.startDate):""}
                      dateFormat="dd/MM/yyy"
                      name='startDate'
                      className="input-margin"
                      isclearable={true}
                      placeholder={'Uplift Date Range'}
                      placeholdertext={'Uplift Date Range'}
                      onChange={onDateChange} />
                  </>
            </button>

          </div>
          <ToastContainer />
         { viewDetailsSalesNew?<div className='flexRow sm-scrollbar margBottom10'>
                 <div className='margTop10'></div>

            <div className="col-lg-3 card-container-sales-header card-sales"  style={{backgroundColor:"#1d3f4f",padding:'10px',marginRight:'0.6rem',borderRadius:'5px'}} key={1 + '-1fincial-year-sales'}>
              <>
              <div className="card-content2" style={{cursor:'pointer'}}>
                <div className='flexRow justifyContentSpaceBetween'>
                <div className="h6">
                    Total Sales
                </div>
                   <img className="dashboard-header-main-icon floatRight pb-1" alt='Current Month Avg Orders' src={totalSales} />
                </div>
                { false?<div className='h4 flexRow justifyContentCenter alignItemsCenter'>

                  <img src={LoadingIn}style={{width:'25px',height:'25px'}} alt="Loading" /></div>: <><div className="h4">
                  €741.05
                 </div> <div className='h6'>/ 40 orders
across 7 of 11 groups with sales</div>   </>              }

            </div>
              </>


        </div>
        <div className="col-lg-3 card-container-sales-header card-sales"  style={{backgroundColor:"#1d3f4f",padding:'10px',marginRight:'0.6rem',borderRadius:'5px'}} key={2 + '-1fincial-year-sales'}>
            <div className="card-content2">
                        <div className='flexRow justifyContentSpaceBetween'>
                <div className="h6">
                    POS Sync Status
                </div>
                <img className="dashboard-header-main-icon floatRight pb-1" alt='Current Month Avg Orders' src={monitor} />

                </div>
                { false?<div className='h4 flexRow justifyContentCenter alignItemsCenter'><img src={LoadingIn}style={{width:'25px',height:'25px'}} alt="Loading" /></div>: <>
                <div className="h4">
                  20/44
                </div>
                   <div className="h6">
                Devices has been synced
                </div>
                </>            }


            </div>
        </div>
        <div className="col-lg-3 card-container-sales-header card-sales"  style={{backgroundColor:"#1d3f4f",padding:'10px',marginRight:'0.6rem',borderRadius:'5px'}} key={3 + '-1fincial-year-sales'}>
            <div className="card-content2">
                <div className='flexRow justifyContentSpaceBetween'>
                <div className="h6">
                    Pre-Booked Meals
                </div>
                                                 <img className="dashboard-header-main-icon floatRight pb-1" alt='Current Month Avg Orders' src={totalOrders} />

                </div>

                { false?<div className='h4 flexRow justifyContentCenter alignItemsCenter'><img src={LoadingIn}style={{width:'25px',height:'25px'}} alt="Loading" /></div>: <>
                <div className="h4">
                  5
                </div>
                 <div className="h6">
                Pre-booked meals served inflight
                </div>
                </>                 }


            </div>
        </div>
        <div className="col-lg-3 card-container-sales-header card-sales"  style={{backgroundColor:"#1d3f4f",padding:'10px',marginRight:'0.6rem',borderRadius:'5px'}} key={4 + '-1fincial-year-sales'}>
            <div className="card-content2">

                      <div className='flexRow justifyContentSpaceBetween'>
                <div className="h6">
                   Sales by Payment Type
                </div>
                <img className="dashboard-header-main-icon floatRight pb-1" alt='Current Month Avg Orders' src={pieChartIcon} />
               </div>
                { false?<div className='h4 flexRow justifyContentCenter alignItemsCenter'><img src={LoadingIn}style={{width:'25px',height:'25px'}} alt="Loading" /></div>:
                <>

                <div className='flexCol justifyContentSpaceBetween margTop8'>
                  <div className='flexRow justifyContentSpaceBetween margBottom10'>
                    Card
                       <div className='flexRow justifyContentFlexEnd'>
                    €162.21
                    </div>
                    </div>
                     <div className='flexRow justifyContentSpaceBetween margBottom10'>
                     Cash
                     <div className='flexRow justifyContentFlexEnd'>
                     €229.04
                    </div>
                    </div>
                     <div className='flexRow justifyContentSpaceBetween'>
                    Others
                    <div className='flexRow justifyContentFlexEnd'>
                      349.80
                    </div>
                    </div>



                </div>


                </>

                  }
            </div>
        </div>
          </div>:<></>}
<div className='container-fluid dashboard-summary-container' style={{height:'80vh',overflowY:'scroll'}}>
{viewSalesNew?<SalesAccordion/>:<></>}
</div>

        </>
      }

      {
     !ready &&<div className='overlay_hide sub'></div>
      }
    </div>
  )
}